<template>
  <div id="annonce-create-step-right-part"
       class="row col-12 col-md-8 d-flex justify-content-center justify-content-md-start pl-md-0 mt-3 mt-md-0 styled-scrollbar-custom pr-under-md-0 pl-under-md-0">
    <div id="annonce-create-step-right-part-inside" class="w-100">
      <div v-if="isLicensedAndNeedVIN" class="col-12 pl-0 pr-0 mb-1">
        <div class="d-flex justify-content-between align-items-center mb-1">
          <div class="small-text"> {{ $t('annonce.vehicle.vin') }} <b>{{ $t('annonce.vehicle.vin.mandatory') }}</b>
          </div>
          <i class="secondary-text-color ph-custom ph-question-fill cursor-pointer" @click="openVinInfoModal"/>
        </div>
        <b-form-group
          :invalid-feedback="vin.invalidFeedback"
          :vin="vin.state"
          label-for="vin-input">
          <b-form-input
            id="vin-input"
            v-model="vin.value"
            :formatter="IdentifierUtils.formatVin"
            :state="vin.state"
            @change="setAnnonce;updateFeedbackVin()">
          </b-form-input>
        </b-form-group>
      </div>

      <div v-if="isLicensedAndNeedVIN" class="col-12 pl-0 pr-0 mb-1">
        <b-form-group
          :invalid-feedback="fiscalPower.invalidFeedback"
          :label="$t('annonce.vehicle.engine.Power')"
          class="small-text"
          label-for="engine-power-input">
          <b-form-input
            id="engine-power-input"
            v-model="fiscalPower.value"
            :state="fiscalPower.state"
            min="0"
            step="1"
            type="number"
            @change="setAnnonce">
          </b-form-input>
        </b-form-group>
      </div>

      <AutocompleteField
        v-if="isLicensedAndNeedVIN"
        :key="autocompleteKey"
        ref="autocomplete"
        v-model="finitions.value"
        :initial-value="this.annonce.finitions.value"
        :input-label="$t('annonce.vehicle.Finitions')"
        :invalidFeedback="finitions.invalidFeedback"
        :items="finishes"
        :need-create-if-empty="true"
        :ready-to-set-initial-value="readyToSetInitialType"
        :state="finitions.state"
        class="col-12 pl-0 pr-0 mb-1"
        input-class="small-text mb-4"
        input-id="type-input"
        @createNewItem="createNewItem"
        @newSelectedValue="getSelectedType">
      </AutocompleteField>


      <div v-if="hasWindowEngravingVehicleType" class="col-12 pl-0 pr-0 mt-1">
        <b-form-group v-slot="{ ariaDescribedby }" :invalid-feedback="hasWindowEngraving.invalidFeedback"
                      :state="hasWindowEngraving.state">
          <b-form-checkbox v-model="hasWindowEngraving.value" class="mb-3 mt-2 radio-proprio" @change="setAnnonce">
            {{ $t('annonce.has.WindowEngraving') }}
          </b-form-checkbox>
        </b-form-group>
      </div>

      <div class="col-12 pl-0 pr-0 mb-1">
        <b-form-group
          :invalid-feedback="annonceDescription.invalidFeedback"
          :label="$t('annonce.context.robbery')"
          class="small-text"
          label-for="annonceDescription-input">
          <b-form-textarea
            id="annonceDescription-input"
            v-model="annonceDescription.value"
            :state="annonceDescription.state"
            @change="setAnnonce">
          </b-form-textarea>
        </b-form-group>
      </div>
      <annonce-create-vehicle-generic-modal
        :brand-id="this.annonce.brand.value"
        :initial-name="customName"
        :model-id="this.annonce.model.value"
        :vehicle-type-id="this.annonce.vehicleType.value"
        controller-name="modelFinish"
        label-input="annonce.empty.create.finish.label"
        method-name="createCustomModelFinish"
        title-modal="annonce.empty.create.finish.title"
        @returnCreateCustom="getCreatedCustom">
      </annonce-create-vehicle-generic-modal>
    </div>

    <b-modal
      id="vin-info-modal"
      ref="modal"
      centered
      class="vin-info-modal"
      hide-footer>
      <template #modal-header="{ close }" style="justify-content: center !important;">
        <span class="vin-info-header-icon">
          <i class="ph-custom ph-question-fill" style="font-size: 60px; color: var(--main-grey-dark);"/>
        </span>
      </template>

      <div>
        <p class="page-title vin-info-title mt-0 mb-3" v-html="$t('vin.info.title')"></p>
        <p class="vin-info-text mt-2" v-html="$t('vin.info.content')"></p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import api from "../../../services/api";
import AutocompleteField from "../../../components/b122/editFields/AutocompleteField";
import AnnonceCreateVehicleGenericModal from "../../../components/annonce/AnnonceCreateVehicleGenericModal";
import IdentifierUtils from "../../../utils/IdentifierUtils";

export default {
  name: "AnnonceCreateStep5",

  components: {
    AutocompleteField,
    AnnonceCreateVehicleGenericModal
  },

  emits: ["updateAnnonce"],

  props: {
    annonce: {
      required: true,
      type: Object
    },
    isLicensed: {
      required: true,
    },
    hasWindowEngravingVehicleType: {
      required: true,
    },
    hasVIN: {
      required: true,
    },

  },

  data() {
    return {
      IdentifierUtils: IdentifierUtils,

      autocompleteKey: 0,
      customName: null,
      readyToSetInitialType: false,
      vin: {
        state: null,
        invalidFeedback: null,
        value: null
      },
      annonceDescription: {
        state: null,
        invalidFeedback: null,
        value: null
      },
      hasWindowEngraving: {
        state: null,
        invalidFeedback: null,
        value: null
      },
      fiscalPower: {
        state: null,
        invalidFeedback: null,
        value: null
      },
      finitions: {
        state: null,
        invalidFeedback: null,
        value: null,
      },
      finishes: [],
    }
  },

  watch: {
    'fiscalPower.value'(val) {
      if (val !== null && val !== '') {
        if (this.fiscalPower.value < 0) {
          this.fiscalPower.value = 0
        } else {
          this.fiscalPower.value = Math.round(val)
        }
      }
    },
    'isLicensed'(val) {
      if (val && this.isLicensed) {
        this.fetchFinishesforModel()
      }
    }
  },

  async mounted() {
    this.readyToSetInitialType = false
    if (this.isLicensed) {
      await this.fetchFinishesforModel()
    }
    await this.setInitialValues()
  },

  computed: {
    isLicensedAndNeedVIN() {
      return this.isLicensed === true && this.hasVIN === true
    },
  },


  methods: {

    setAnnonce() {
      this.annonce.annonceDescription = this.annonceDescription
      this.annonce.vin = this.vin
      this.annonce.hasWindowEngraving = this.hasWindowEngraving
      this.annonce.fiscalPower = this.fiscalPower
      this.annonce.finitions = this.finitions
      this.$emit('updateAnnonce', this.annonce)
    },


    async setInitialValues() {
      this.annonceDescription = this.annonce.annonceDescription
      this.vin = this.annonce.vin
      this.hasWindowEngraving = this.annonce.hasWindowEngraving
      this.fiscalPower = this.annonce.fiscalPower
    },

    async fetchFinishesforModel() {
      api
        .post(`/modelFinish/getAllActivatedForModel/${this.annonce.model.value}`)
        .then(async response => {
          response.data.forEach(finish => {
            this.finishes.push({...finish, state: null, invalidFeedback: null})
            this.finitions = this.annonce.finitions
            this.readyToSetInitialType = true
          })
        })
    },

    getSelectedType(data) {
      if (data !== null) {
        this.finitions.value = data;
      } else {
        this.finitions.value = null;
      }
      this.setAnnonce();
    },

    createNewItem(newName) {
      this.customName = newName
      this.$bvModal.show('create-vehicle-generic')
    },

    async getCreatedCustom(createdBaseVehicle) {
      if (createdBaseVehicle.id || createdBaseVehicle.value) {
        this.autocompleteKey += 1;
        this.$set(this.finishes, this.finishes.length, {
          ...createdBaseVehicle,
        });
        this.finitions.value = createdBaseVehicle.id;
        this.annonce.finitions.value = createdBaseVehicle.id;
        this.setAnnonce()
      }
    },

    openVinInfoModal() {
      this.$bvModal.show('vin-info-modal')
    },

    updateFeedbackVin() {
      var newVal = this.vin.value
      if (newVal === null || newVal === "" || newVal.trim() === "") {
        this.vin.value = null
        this.vin.state = null
        this.vin.invalidFeedback = null
        return
      }
      const validVin = IdentifierUtils.validVinFormat(newVal)
      if (validVin) {
        this.vin.value = validVin
        this.vin.state = true
        this.vin.invalidFeedback = null
      } else {
        this.vin.state = false
        this.vin.invalidFeedback = this.$i18n.t('annonce.vin.invalidFeedBack')
      }
    },

  },
}
</script>

<!-- not scoped car modal -->
<style>
#vin-info-modal .modal-content,
#vin-info-modal .modal-header,
#vin-info-modal .modal-body,
#vin-info-modal .modal-footer {
  background-color: var(--main-black-dark);
}

.vin-info-text {
  color: var(--main-grey-medium);
}

#vin-info-modal .modal-content {
  overflow: hidden;
  border-radius: 30px;
}

#vin-info-modal .modal-header {
  justify-content: center !important;
}

@media (max-width: 767px) {
  #vin-info-modal .modal-content {
    display: flex;
    overflow: auto;
  }

  #vin-info-modal .modal-body {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #vin-info-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
  }

  #vin-info-modal .modal-content {
    padding: 0;
    margin: 8px;
  }

  .vin-info-text {
    padding: 10px;
  }

}

@media (max-height: 852px) {
  #vin-info-modal .modal-content {
    overflow: auto;
  }

  .vin-info-text {
    padding: 0px;

  }
}

</style>
<style scoped>
/* pour affichage desktop (md) : scroll pas sur la page entière mais sur le contenu modifiable uniquement */
@media (min-width: 769px) {
  #annonce-create-step-right-part {
    height: 100%;
    overflow: auto;
  }

  #annonce-create-step-right-part-inside {
    padding-left: 3px; /* pour voir le border sur les input focus */
    width: 100%;
    margin-bottom: auto; /* si il n'y a pas assez d'items pour remplir la hauteur */
  }
}

.radio-proprio {
  color: var(--main-grey-light);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
</style>



// WEBPACK FOOTER //
// src/views/annonce/AnnonceCreate/AnnonceCreateStep5.vue